<article class="message">
    <core-helper-box-header-user-date 
        [date]="message.date" 
        [user]="message.user" 
        [posText]="'LEFT A <strong>MESSAGE</strong>'" 
        [feedback]="feedback" 
        [versionShares]="versionShares"> 
    </core-helper-box-header-user-date>
    <div class="content">
        <div class="message-text" [innerHTML]="message.text"></div>
    </div>
</article>
